import { omit, equals } from 'util/objects'
import storage from 'util/storage'

import {
  BOOTSTRAP_WIDGETS,
  FETCH_WIDGETS_REQUEST,
  FETCH_WIDGETS_SUCCESS,
  FETCH_WIDGETS_FAILURE,
  FETCH_WIDGET_SETTINGS_REQUEST,
  FETCH_WIDGET_SETTINGS_SUCCESS,
  FETCH_WIDGET_SETTINGS_FAILURE,
  FETCH_WIDGET_SNIPPET_REQUEST,
  FETCH_WIDGET_SNIPPET_SUCCESS,
  FETCH_WIDGET_SNIPPET_FAILURE,
  UPDATE_WIDGET_SETTINGS_REQUEST,
  UPDATE_WIDGET_SETTINGS_SUCCESS,
  UPDATE_WIDGET_SETTINGS_FAILURE,
  PUBLISH_WIDGET_SETTINGS_REQUEST,
  PUBLISH_WIDGET_SETTINGS_SUCCESS,
  PUBLISH_WIDGET_SETTINGS_FAILURE,
  REVERT_WIDGET_SETTINGS_REQUEST,
  REVERT_WIDGET_SETTINGS_SUCCESS,
  REVERT_WIDGET_SETTINGS_FAILURE,
  CREATE_WIDGET_REQUEST,
  CREATE_WIDGET_SUCCESS,
  CREATE_WIDGET_FAILURE,
  UPDATE_WIDGET_REQUEST,
  UPDATE_WIDGET_SUCCESS,
  UPDATE_WIDGET_FAILURE,
  DELETE_WIDGET_REQUEST,
  DELETE_WIDGET_SUCCESS,
  DELETE_WIDGET_FAILURE,
  UPDATE_WIDGET_PREVIEW_MESSAGE,
  UPDATE_WIDGET_DEMO_SETTINGS,
} from './types'
import { IGNORED_SETTINGS_KEYS } from './constants'

export const demoSettings = {
  'contact.enabled': undefined, // HACK (jscheel): Use undefined to make sure we don't override in demo settings selector
  'contact.id': null,
  icon: 'chat',
  iconDisplay: 'both',
  iconStyle: 'outline',
  iconText: 'Need a hand?',
  'kb.enabled': undefined,
  'kb.id': null,
  primaryColor: '#6187e0',
  widgetStyle: 'user',
}

const defaultState = {
  byId: {},
  ids: [],
  isLoading: false,
  isSaving: false,
  isBootstrapped: false,
  settings: {},
  demoSettings,
  snippet: '',
  error: null,
}

const reducers = {}

reducers[BOOTSTRAP_WIDGETS] = state => {
  return {
    ...state,
    isBootstrapped: true,
  }
}

reducers[FETCH_WIDGETS_REQUEST] = state => {
  return {
    ...state,
    isLoading: true,
  }
}

reducers[FETCH_WIDGETS_SUCCESS] = (state, action) => {
  const {
    payload: { widgets: data },
  } = action

  const newById = {}
  const newIds = []

  data.forEach(widget => {
    newById[widget.id] = { ...state.byId[widget.id], ...widget }
    newIds.push(widget.id)
  })

  return {
    ...state,
    byId: { ...state.byId, ...newById },
    ids: newIds,
    isLoading: false,
  }
}

reducers[FETCH_WIDGETS_FAILURE] = (state, action) => {
  const { payload: err } = action.data

  return {
    ...state,
    isLoading: false,
    error: err,
  }
}

reducers[FETCH_WIDGET_SETTINGS_REQUEST] = state => {
  return {
    ...state,
    isLoading: true,
  }
}

reducers[FETCH_WIDGET_SETTINGS_SUCCESS] = (state, action) => {
  const { widgetId, data } = action

  return {
    ...state,
    settings: {
      ...state.settings,
      [widgetId]: omit(['primaryColorRgb'], data),
    },
    isLoading: false,
  }
}

reducers[FETCH_WIDGET_SETTINGS_FAILURE] = (state, action) => {
  const { err } = action.data

  return {
    ...state,
    isLoading: false,
    error: err,
  }
}

reducers[FETCH_WIDGET_SNIPPET_REQUEST] = state => {
  return {
    ...state,
    isLoading: true,
  }
}

reducers[FETCH_WIDGET_SNIPPET_SUCCESS] = (state, action) => {
  const { data } = action

  return {
    ...state,
    snippet: data,
    isLoading: false,
  }
}

reducers[FETCH_WIDGET_SNIPPET_FAILURE] = (state, action) => {
  const { err } = action.data

  return {
    ...state,
    isLoading: false,
    error: err,
  }
}

reducers[UPDATE_WIDGET_SETTINGS_REQUEST] = (state, action) => {
  const { widgetId, data } = action

  return {
    ...state,
    settings: {
      ...state.settings,
      [widgetId]: data,
    },
    isSaving: true,
  }
}

reducers[UPDATE_WIDGET_SETTINGS_SUCCESS] = (state, action) => {
  const { widgetId, data } = action
  const existingSettings = omit(
    IGNORED_SETTINGS_KEYS,
    state.settings[widgetId] || {}
  )
  const newSettings = omit(IGNORED_SETTINGS_KEYS, data)
  if (equals(existingSettings, newSettings)) {
    return {
      ...state,
      isSaving: false,
      error: null,
    }
  }
  return {
    ...state,
    settings: {
      ...state.settings,
      [widgetId]: newSettings,
    },
    isSaving: false,
    error: null,
  }
}

reducers[UPDATE_WIDGET_SETTINGS_FAILURE] = (state, action) => {
  const { err } = action.data

  return {
    ...state,
    isSaving: false,
    error: err,
  }
}

reducers[PUBLISH_WIDGET_SETTINGS_REQUEST] = state => {
  return {
    ...state,
    isSaving: true,
  }
}

reducers[PUBLISH_WIDGET_SETTINGS_SUCCESS] = (state, action) => {
  const { widgetId, data } = action

  return {
    ...state,
    settings: {
      ...state.settings,
      [widgetId]: omit(['primaryColorRgb'], data),
    },
    isSaving: false,
    error: null,
  }
}

reducers[PUBLISH_WIDGET_SETTINGS_FAILURE] = (state, action) => {
  const { err } = action.data

  return {
    ...state,
    isSaving: false,
    error: err,
  }
}

reducers[REVERT_WIDGET_SETTINGS_REQUEST] = state => {
  return {
    ...state,
    isSaving: true,
  }
}

reducers[REVERT_WIDGET_SETTINGS_SUCCESS] = (state, action) => {
  const { widgetId, data } = action

  return {
    ...state,
    settings: {
      ...state.settings,
      [widgetId]: omit(['primaryColorRgb'], data),
    },
    isSaving: false,
    error: null,
  }
}

reducers[REVERT_WIDGET_SETTINGS_FAILURE] = (state, action) => {
  const { err } = action.data

  return {
    ...state,
    isSaving: false,
    error: err,
  }
}

reducers[CREATE_WIDGET_REQUEST] = state => {
  return {
    ...state,
    isSaving: true,
  }
}

reducers[CREATE_WIDGET_SUCCESS] = (state, action) => {
  const { data } = action

  return {
    ...state,
    ids: [...state.ids, data.id],
    byId: {
      ...state.byId,
      [data.id]: omit(['primaryColorRgb'], data),
    },
    demoSettings: {},
    isSaving: false,
    error: null,
  }
}

reducers[CREATE_WIDGET_FAILURE] = (state, action) => {
  const { err } = action.data

  return {
    ...state,
    isSaving: false,
    error: err,
  }
}

reducers[UPDATE_WIDGET_REQUEST] = state => {
  return {
    ...state,
    isSaving: true,
  }
}

reducers[UPDATE_WIDGET_SUCCESS] = (state, action) => {
  const { data } = action

  return {
    ...state,
    byId: {
      ...state.byId,
      [data.id]: data,
    },
    isSaving: false,
    error: null,
  }
}

reducers[UPDATE_WIDGET_FAILURE] = (state, action) => {
  const { err } = action.data

  return {
    ...state,
    isSaving: false,
    error: err,
  }
}

reducers[DELETE_WIDGET_REQUEST] = state => {
  return {
    ...state,
    isSaving: true,
  }
}

reducers[DELETE_WIDGET_SUCCESS] = (state, action) => {
  const { widgetId } = action

  return {
    ...state,
    ids: state.ids.filter(id => id !== widgetId),
    byId: omit([widgetId], state.byId),
    settings: omit([widgetId], state.settings),
    isSaving: false,
    error: null,
  }
}

reducers[DELETE_WIDGET_FAILURE] = (state, action) => {
  const { err } = action.data

  return {
    ...state,
    isSaving: false,
    error: err,
  }
}

reducers[UPDATE_WIDGET_PREVIEW_MESSAGE] = (state, action) => {
  const { hide } = action.data

  storage.set('hideWidgetPreviewMessage', hide)
  return {
    ...state,
    hidePreviewMessage: hide,
  }
}

reducers[UPDATE_WIDGET_DEMO_SETTINGS] = (state, action) => {
  const { data } = action
  return {
    ...state,
    demoSettings: {
      ...state.demoSettings,
      ...omit(['primaryColorRgb'], data),
    },
  }
}

export default function reducer(state = defaultState, action) {
  const handler = reducers[action.type]
  if (handler) return handler(state, action)
  return state
}
